import { render, staticRenderFns } from "./EditBranchModal.vue?vue&type=template&id=0b7879ca&scoped=true"
import script from "./EditBranchModal.vue?vue&type=script&lang=js"
export * from "./EditBranchModal.vue?vue&type=script&lang=js"
import style0 from "./EditBranchModal.vue?vue&type=style&index=0&id=0b7879ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7879ca",
  null
  
)

export default component.exports